fx.ns("shared.renderers", class SocialPictureRenderer extends fx.components.Image {
    
	constructor(data)
	{
        super(data);
        this.cover = true;
    }

    onReady()
    {
        super.onReady();

        this.on("click", this._onClick);
    }

    _onClick()
    {
        this.data.select();
    }

    onDataUpdated(action)
    {
        if (action.impacts("selected") || action.type == "init")
            this.toggleClass("selected", this.data.selected);
    }

    update()
    {
        this.node.innerHTML = "<div class='image' style='background-image: url(" + this.data.thumb + ")'></div>" + fx.assets.readyIcon.render();
        this._refreshHandlers();
		this.updateDisplay();
    }
}); 